import { SURVEY_PATH } from "@/modules/survey/pages/survey";
import { generatePath, Navigate } from "react-router-dom";

export function OpenSurvey() {
  return (
    <Navigate
      to={generatePath(SURVEY_PATH, {
        id: new URL(window.location.href).searchParams.get("id"),
      })}
    />
  );
}
